export default __webpack_public_path__ + "static/media/pointsicon.54e36369.svg";